export enum AccessPermission {
  Read = 1,
  Write = 2,
}

const a = AccessPermission;
export function accessDisplay(arr: Array<AccessPermission>): string {
  if (arr.length === 1) {
    switch (arr[0]) {
      case a.Read:
        return "read";
      case a.Write:
        return "write";
      default:
        return ""
    }
  } else if (arr.length === 2) {
    if ( [a.Read, a.Write].every( e => arr.includes(e) ) ) {
      return "read, write"
    } else {
      return ""
    }
  }

}